// src/pages/FabricGuide.js
import React from "react";

const FabricGuide = () => {
  return (
    <div className="container max-w-6xl mx-auto px-4 py-10">
      {/* Heading */}
      <h1 className="text-2xl font-bold text-left mb-6">Fabric Guide</h1>

      {/* Paragraph */}
      <p className="text-md text-black text-left mb-8 leading-relaxed">
        Determining the proper fabric type is just as important as choosing the
        right size and color. With so many different kinds of fabric available,
        it can be hard to know what's best for your team's needs. That's why we
        made this comprehensive guide to the most popular fabrics used to make
        clothing and accessories.
      </p>

      {/* Horizontal Line */}
      <hr className="border-gray-300 mb-8" />

      {/* Image aligned with text */}
      <img
        src="/images/fabric-guide.jpg" // replace with your actual image path
        alt="Fabric Guide"
        className="shadow-md w-full h-auto"
      />
    </div>
  );
};

export default FabricGuide;
